var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detailPage"},[_c('v-header',{attrs:{"resultMsg":_vm.resultMsg}}),_c('v-content',{attrs:{"resultMsg":_vm.resultMsg}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }